import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-terms-of-services",
  imports: [],
  templateUrl: "./terms-of-services.component.html",
  styleUrl: "./terms-of-services.component.css",
})
export class TermsOfServicesComponent {
  constructor(private router: Router) {
    this.lastUpdated = new Date().toLocaleDateString();
  }

  lastUpdated: string;

  goBack(): void {
    this.router.navigate([""]);
  }
}
